import { Box, styled, TextField, Theme, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { dialogStyles as baseDialogStyles, dialogTitleStyles as baseTitleStyles } from '../../styles/utilities'
import { moduleColors } from '../../theme/tokens'

export const DialogIcon = styled('img')({
  width: 50,
  height: 50,
  borderRadius: '50%',
})

export const dialogStyles = (theme: Theme) => ({
  ...baseDialogStyles(theme, {
    maxWidth: '800px',
    minHeight: '50vh',
    maxHeight: '95vh',
    padding: '30px',
  }),
  color: '#fff',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
  },
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiDateRangePicker-root': {
    width: '100%',
  },
})

export const personIconStyles = {
  color: moduleColors.contacts,
}

export const dialogTitleStyles = (theme: Theme) => ({
  ...baseTitleStyles(theme),
  textAlign: 'center' as const,
})

export const boxStyles = {
  display: 'flex',
  flexDirection: 'row' as const,
  justifyContent: 'space-between',
  alignItems: 'center',
}

export const dialogContentStyles = {
  flex: 1,
  overflowY: 'auto' as const,
  padding: '16px 0',
  width: 'auto',
  maxWidth: '700px',
  margin: '0 auto',
}

/**
 * Input styles for use with InputProps.style (flat CSS only, no nested selectors)
 * Note: This is used with the native style prop, not sx, so it cannot have nested selectors
 */
export const inputStyles = (theme: Theme) => ({
  color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'black',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgb(229, 229, 229)',
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
})

export const ContactTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30 43 59)' : '#ffffff',
  textAlign: 'left' as const,
  borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '4px',
  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0,0,0,0.22)',
  },
}))

export const InfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(30, 39, 53)' : '#f4f6f8',
  padding: theme.spacing(6),
  borderRadius: '25px',
}))

export const InfoRow = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  position: 'relative',
}))

export const InfoLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  fontSize: '1.175rem',
  marginBottom: theme.spacing(0.5),
}))

export const InfoValueWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  paddingBottom: theme.spacing(1),
}))

export const InfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: '1rem',
}))

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2',
  fontWeight: 700,
  fontSize: '1rem',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export const Underline = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '1px',
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
}))

export const CityStateZipRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
  position: 'relative',
}))
